import React from "react";

export const GanttAddTaskIcon = ({ color }: { color?: string }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" fill="none" viewBox="0 0 13 12">
      <path
        fill={color ?? "currentColor"}
        fillRule="evenodd"
        d="M6.825 5.214V0H5.25v5.214H0v1.565h5.25V12h1.575V6.78h5.247V5.213z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};

export const ToolbarGanttAddTaskIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="15" fill="none" viewBox="0 0 21 15">
    <rect width="19.294" height="14" x="0.854" y="0.5" stroke="#fff" rx="2.5"></rect>
    <path stroke="#fff" strokeLinecap="round" d="M7.854 7.5h5.382M10.545 4.809v5.382"></path>
  </svg>
);
